import styled from "styled-components";

export const FooterContainer = styled.footer`
  background-color: ${(props) =>
    props.theme.theme.FOOTER.BACKGROUND} !important;

  p {
    color: ${(props) => props.theme.theme.TEXT.LIGHT} !important;
  }

  a {
    color: white;
    text-decoration: none;
  }

  ul {
    list-style-type: none;
    padding: 0;
  }

  .cl-social {
    font-size: xx-large;
  }
`;

export const FooterLink = styled.a`
  color: #fff;
  text-decoration: none;
  font-size: 1rem;
  &:hover {
    color: #fff;
    text-decoration: none;
  }
`;
